import React, { Component } from 'react';
import Slider from "react-slick";
import styled, { css } from 'styled-components'
import "../styles/slick.css";
import "../styles/slick-theme.css";
import { PageContainer, BottomButtons, Button } from '../components/styledComponents'

const OnboardingScreen = styled.div`
	width: 414px;
	height: 526px;
	background-image: url('${props => props.src}');
	background-size: cover;
	background-position: center;
`;

const SignupButton = styled(Button)`
	margin: 0 10px;
`

const NextButton = styled(Button)`
  position: absolute;
  bottom: -120px;

  ${props => props.hidden && `
    display: none;
  `}
`

function SampleNextArrow(props) {
  const { onClick, enabled } = props;
  return (
    <NextButton
      hidden={!enabled}
      onClick={onClick}
    >Next</NextButton>
  );
}

export default class Onboarding extends Component {
  state = {
    index: 0,
  };
  proceed() {
    if (this.state.index === 2) {
      this.props.onProceed();
    }
  }

  sliderChanged(index) {
    this.setState({ index });
  }

  render() {
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      afterChange: this.sliderChanged.bind(this),
      nextArrow: <SampleNextArrow enabled={this.state.index !== 2} />
    };

    return (
      <PageContainer style={{ paddingTop: '40px' }}>
        <Slider {...settings}>
          <OnboardingScreen src="images/splash_1.png" />
          <OnboardingScreen src="images/splash_2.png" />
          <OnboardingScreen src="images/splash_3.png" />
        </Slider>
        { this.state.index === 2 && <BottomButtons>
        	<SignupButton onClick={this.proceed.bind(this)}>Sign-Up</SignupButton>
        	<SignupButton onClick={this.proceed.bind(this)}>Sign-In</SignupButton>
        </BottomButtons> }
      </PageContainer>
    );
  }
}
